module.exports = __webpack_public_path__ + "img/folder-1.99e08a91.png";